export class NotificationService {
  constructor() {
    this.container = null;
    this.notifications = [];
    this.init();
  }

  init() {
    if (typeof document === 'undefined') return;
    
    this.container = document.createElement('div');
    this.container.className = 'tc-notification-container';
    this.container.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 9999;
      pointer-events: none;
    `;
    document.body.appendChild(this.container);
  }

  show(message, type = 'info', duration = 3000) {
    const id = Date.now() + Math.random();
    const notification = {
      id,
      message,
      type,
      duration
    };

    this.notifications.push(notification);
    this.render(notification);

    setTimeout(() => {
      this.remove(id);
    }, duration);

    return id;
  }

  success(message, duration) {
    return this.show(message, 'success', duration);
  }

  error(message, duration) {
    return this.show(message, 'error', duration);
  }

  warning(message, duration) {
    return this.show(message, 'warning', duration);
  }

  info(message, duration) {
    return this.show(message, 'info', duration);
  }

  render(notification) {
    const element = document.createElement('div');
    element.className = `tc-notification tc-notification-${notification.type}`;
    element.style.cssText = `
      background: ${this.getBackgroundColor(notification.type)};
      color: white;
      padding: 12px 16px;
      border-radius: 6px;
      margin-bottom: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      font-size: 14px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      max-width: 300px;
      pointer-events: auto;
      opacity: 0;
      transform: translateX(100%);
      transition: all 0.3s ease;
    `;

    element.textContent = notification.message;
    element.dataset.notificationId = notification.id;

    this.container.appendChild(element);

    // Trigger animation
    setTimeout(() => {
      element.style.opacity = '1';
      element.style.transform = 'translateX(0)';
    }, 10);
  }

  remove(id) {
    const element = this.container.querySelector(`[data-notification-id="${id}"]`);
    if (element) {
      element.style.opacity = '0';
      element.style.transform = 'translateX(100%)';
      
      setTimeout(() => {
        if (element.parentNode) {
          element.parentNode.removeChild(element);
        }
      }, 300);
    }

    this.notifications = this.notifications.filter(n => n.id !== id);
  }

  getBackgroundColor(type) {
    const colors = {
      success: '#22c55e',
      error: '#ef4444',
      warning: '#f59e0b',
      info: '#3b82f6'
    };
    return colors[type] || colors.info;
  }

  clear() {
    this.notifications.forEach(notification => {
      this.remove(notification.id);
    });
  }
}

export default new NotificationService();
